var React = require('react');

function PricingSquiggleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.5","d":"M194.5 1.5C184.365 4.81033 176.401 12.1838 167.099 17.1974C142.804 30.2908 118.916 33.4341 92.2301 39.3389C70.8357 44.0729 42.2829 46.3424 29.418 66.6028C23.3615 76.1408 20.2738 86.6082 15.4223 96.6756C10.102 107.716 7.24079 116.127 1 123","stroke":"#DCE3DD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

PricingSquiggleInline.defaultProps = {"width":"196","height":"124","viewBox":"0 0 196 124","fill":"none"};

module.exports = PricingSquiggleInline;

PricingSquiggleInline.default = PricingSquiggleInline;
